import * as signers from 'constants/enums/signer'

export default {
  [signers.UNSELECTED]: 'Nevybraný',
  [signers.SELECTED]: 'Vybraný',
} as const
